/* LOGIXA homepage content — CZ. Shape must match de.ts exactly. */

export const cz = {
  nav: {
    links: [
      { label: 'Produkt', href: '#plattform' },
      { label: 'Řešení', href: '#disposition' },
      { label: 'Integrace', href: '#integrationen' },
      { label: 'Ceník', href: '#preise' },
      { label: 'Zdroje', href: '/docs' },
    ],
    login: 'Přihlášení',
    demo: 'Domluvit demo',
    menu: 'Menu',
  },

  hero: {
    kicker: 'TRANSPORT MANAGEMENT SYSTEM',
    h1: 'TMS software pro dopravce, kterým nestačí jen dispečink.',
    sub: 'Zakázky, dispečink, řidiči, vozový park, GPS, dokumenty a fakturace v jedné platformě. LOGIXA propojuje celou dopravní organizaci — od zakázky po fakturu.',
    primary: 'Domluvit demo',
    secondary: 'Podívat se na demo',
    trust: ['V souladu s GDPR', 'Hosting v Německu', '9 jazyků', 'Spuštění za 12 dní'],
    demoNote: 'Demonstrační data',
  },

  mock: {
    search: 'Hledat…',
    user: 'Max Mustermann',
    role: 'ADMIN',
    nav: ['Přehled', 'Zakázky', 'Dispečink', 'Vozidla', 'Řidiči', 'Plánování tras', 'GPS sledování', 'Dokumenty', 'Zprávy', 'Reporty', 'Fakturace', 'Nastavení'],
    live: 'LIVE',
    card: {
      id: 'FLEET-DEMO-118',
      route: 'Hamburk, DE → Rotterdam, NL',
      etaLbl: 'ETA',
      eta: 'Dnes, 14:30',
      driverLbl: 'ŘIDIČ',
      driver: 'John D.',
      progress: 64,
    },
    ordersTitle: 'Aktivní zakázky',
    orders: [
      { id: 'FLEET-DEMO-118', state: 'NA CESTĚ', tone: 'go' },
      { id: 'FLEET-DEMO-117', state: 'NA CESTĚ', tone: 'go' },
      { id: 'FLEET-DEMO-116', state: 'NAKLÁDKA', tone: 'load' },
      { id: 'FLEET-DEMO-115', state: 'NAPLÁNOVÁNO', tone: 'plan' },
      { id: 'FLEET-DEMO-114', state: 'DOKONČENO', tone: 'done' },
    ],
    kpiTitle: 'KPI dnes',
    kpis: [
      { lbl: 'ZAKÁZKY', val: '850', delta: '+14 %' },
      { lbl: 'PRÁZDNÉ JÍZDY', val: '14 %', delta: '−16 %' },
      { lbl: 'OBRAT', val: '€92K', delta: '+18 %' },
    ],
    statusTitle: 'Stav vozidel',
    status: [
      { n: '104', lbl: 'NA CESTĚ' },
      { n: '18', lbl: 'NAKLÁDKA' },
      { n: '7', lbl: 'VYKLÁDKA' },
      { n: '4', lbl: 'SERVIS' },
      { n: '2', lbl: 'NEAKTIVNÍ' },
    ],
    plates: [
      { p: 'HH-LOG 33', tone: 'go' },
      { p: 'B-KT 155', tone: 'acc' },
      { p: 'K-AB 147', tone: 'idle' },
    ],
  },

  integrations: {
    label: 'Integrace do vaší stávající\nlogistické infrastruktury',
    items: ['TIMOCOM', 'Trans.eu', 'DATEV', 'Stripe', 'SEPA', 'n8n', 'Make', 'Zapier'],
  },

  platform: {
    kicker: 'PLATFORMA',
    h2: 'Vaše doprava. Jeden systém.',
    sub: 'Žádné excelové tabulky. Žádné oddělené systémy pro řidiče, GPS a fakturaci. Žádné hledání informací v pěti nástrojích.',
    areas: [
      {
        n: '01',
        title: 'Zakázky a dispečink',
        desc: 'Zadávat zakázky, přiřazovat řidiče a vozidla, plánovat trasy a sledovat stav přepravy v reálném čase.',
        chips: ['Zakázky', 'AI dispečink', 'Plánování tras', 'ePOD'],
      },
      {
        n: '02',
        title: 'Vozový park a GPS',
        desc: 'Sledovat vozidla živě, plánovat servis, hlídat TCO a spravovat geofence.',
        chips: ['Live GPS', 'TCO', 'Servis', 'Geofencing'],
      },
      {
        n: '03',
        title: 'Řidiči a compliance',
        desc: 'Pracovní doba, dokumenty, tachograf a pravidla EU 561 na jednom místě — dřív, než se lhůty stanou problémem.',
        chips: ['Tachograf', 'EU 561', 'ADR', 'Modul 95'],
      },
      {
        n: '04',
        title: 'Mzdy a finance',
        desc: 'Mzdy, příplatky, výplaty a procesy DATEV propojené přímo s provozními daty přepravy.',
        chips: ['Payroll', 'DATEV', 'SEPA', 'Stripe'],
      },
    ],
    cta: 'Prozkoumat všechny funkce',
  },

  dispatch: {
    kicker: 'INTELIGENTNÍ DISPEČINK',
    h2: 'Dispečink, který myslí s vámi.',
    sub: 'LOGIXA zohlední řidiče, vozidla, doby řízení, dostupnost i trasu a podpoří dispečera při optimálním přiřazení.',
    points: [
      { title: 'AI dispečink', desc: 'Navrhne řidiče a vozidlo odpovídající zakázce.' },
      { title: 'Optimalizace tras', desc: 'Zohlední mýto, vzdálenost, doby řízení a palivo.' },
      { title: 'Diesel Intelligence', desc: 'Naplánuje tankování podle aktuálních cen paliva podél trasy.' },
    ],
    panelTitle: 'Doporučení trasy',
    metrics: [
      { lbl: 'Vzdálenost', val: '1 346 km' },
      { lbl: 'Doba jízdy', val: '17 h 25 min' },
      { lbl: 'Mýto', val: '€ 128,40' },
      { lbl: 'CO₂', val: '1 245 kg' },
    ],
    stopsTitle: 'Doporučená tankování',
    live: 'LIVE',
    stops: [
      { city: 'Hannover', price: '€ 1,59', best: false },
      { city: 'Kassel', price: '€ 1,58', best: false },
      { city: 'Frankfurt', price: '€ 1,55', best: true },
      { city: 'Würzburg', price: '€ 1,62', best: false },
    ],
    apply: 'Použít trasu',
    source: 'Zdroje cen: Tankerkönig (DE), prix-carburants (FR), E-Control (AT), MITECO (ES)',
  },

  driver: {
    kicker: 'APLIKACE PRO ŘIDIČE',
    h2: 'Řidič má všechno s sebou.',
    sub: 'Nativní aplikace pro iOS a Android — kompletní průběh trasy od zakázky po podpis, i bez signálu.',
    flow: ['Přijmout zakázku', 'Spustit navigaci', 'Naskenovat dokumenty', 'Podepsat ePOD', 'Uzavřít trasu'],
    chips: ['iOS', 'Android', 'Offline režim', 'Telegram bot', '9 jazyků'],
    phones: [
      {
        tag: 'ZAKÁZKA #DE-1107',
        title: 'Hamburk → Rotterdam',
        rows: [
          { lbl: 'NAKLÁDKA', val: 'Dnes 08:30' },
          { lbl: 'VYKLÁDKA', val: 'Dnes 14:30' },
          { lbl: 'VOZIDLO', val: 'HH-LOG 33' },
          { lbl: 'NÁKLAD', val: '18 palet · 12,4 t' },
        ],
        action: 'Spustit navigaci',
      },
      {
        tag: 'DOKUMENTY',
        title: 'Naskenovat CMR',
        rows: [
          { lbl: 'NÁKLADNÍ LIST', val: 'CMR-2026-4471' },
          { lbl: 'STAV', val: 'Naskenováno · 2 strany' },
          { lbl: 'DODACÍ LIST', val: 'Čeká' },
        ],
        action: 'Nahrát sken',
      },
      {
        tag: 'ePOD',
        title: 'Potvrdit převzetí',
        rows: [
          { lbl: 'PŘÍJEMCE', val: 'De Vries Logistics BV' },
          { lbl: 'PODPIS', val: 'Zaznamenán' },
          { lbl: 'FOTO', val: '3 přílohy' },
        ],
        action: 'Uzavřít trasu',
      },
    ],
  },

  compliance: {
    kicker: 'COMPLIANCE A BEZPEČNOST',
    h2: 'Vidět doby řízení dřív, než se stanou problémem.',
    sub: 'Doby řízení a odpočinku, data z tachografu a končící dokumenty na jednom místě — s varováním, dokud je čas reagovat.',
    points: [
      { title: 'EU 561', desc: 'Aktuální doby řízení a odpočinku u každého řidiče, průběžně vyhodnocované.' },
      { title: 'Tachograf', desc: 'Import DDD souborů a přehled o datech řidiče.' },
      { title: 'Dokumenty', desc: 'Varování před koncem platnosti řidičského průkazu, ADR a Modulu 95.' },
    ],
    dashDriverLbl: 'Řidič',
    dashDriver: 'John D.',
    badge: 'V SOULADU',
    bars: [
      { lbl: 'Řízení dnes', val: '7 h 45 / 9 h', pct: 86, tone: 'warn' },
      { lbl: 'Řízení za týden', val: '38 h 10 / 56 h', pct: 68, tone: 'ok' },
      { lbl: 'Další odpočinek', val: 'za 1 h 15 min', pct: 42, tone: 'ok' },
    ],
    docsTitle: 'Končící dokumenty',
    docs: [
      { lbl: 'Řidičský průkaz', val: '12.03.2027', warn: false },
      { lbl: 'Osvědčení ADR', val: '18.05.2027', warn: true },
      { lbl: 'Modul 95', val: '22.09.2027', warn: false },
    ],
    alerts: '3 AKTIVNÍ VAROVÁNÍ',
  },

  onboarding: {
    kicker: 'PŘECHOD',
    h2: 'Pořád Excel? Žádný problém.',
    sub: 'Převezmeme řidiče, vozidla a obchodní partnery z Excelu, CSV nebo vašeho dosavadního TMS.',
    promoTitle: 'Spuštění za 12 dní.',
    promoSub: 'Rychle. Bezpečně. Bez rizika.',
    promoCta: 'Domluvit demo',
    steps: [
      { tag: 'DEN 1', title: 'Prohlídka procesů', desc: 'Demo a analýza vašich procesů.' },
      { tag: 'DEN 2–4', title: 'Start pilotu', desc: 'Pilotní provoz s reálnými vozidly.' },
      { tag: 'DEN 5–8', title: 'Import dat', desc: 'Převzetí řidičů, vozidel a číselníků.' },
      { tag: 'DEN 9–10', title: 'Školení týmu', desc: 'Školení vašich dispečerů a řidičů.' },
      { tag: 'DEN 11–12', title: 'Ostrý provoz', desc: 'Produkční start s plnou podporou.' },
    ],
  },

  roi: {
    kicker: 'POTENCIÁL ÚSPOR',
    h2: 'Co LOGIXA změní ve vašem vozovém parku.',
    fields: [
      { lbl: 'Vozidla', unit: '' },
      { lbl: 'Řidiči', unit: '' },
      { lbl: 'Zakázek měsíčně', unit: '' },
      { lbl: 'Prům. km na vozidlo a rok', unit: 'km' },
    ],
    panelTitle: 'POTENCIÁL ZA ROK',
    lines: ['Méně administrativy', 'Optimalizované prázdné jízdy', 'Optimalizace paliva'],
    totalLbl: 'Odhadovaný potenciál',
    basisLink: 'Zobrazit základ výpočtu',
    basisClose: 'Skrýt základ výpočtu',
    basis: [
      'Administrativa: 7,50 € na zakázku (zhruba 13 minut při nákladové sazbě 34 €/h) plus 15 € na řidiče a měsíc za evidenci času a přípravu mezd.',
      'Prázdné jízdy: 18 % podíl prázdných kilometrů, z toho 5 % odstranitelných lepším dispečinkem, při nákladu 1,04 € na kilometr.',
      'Palivo: spotřeba 30 l na 100 km a úspora 2 centy na litr díky plánování tankování podél trasy — podle živých cen z Tankerkönig (DE), prix-carburants (FR), E-Control (AT) a MITECO (ES).',
      'Všechny údaje jsou odhad na základě běžných oborových předpokladů, nikoli zaručená úspora.',
    ],
  },

  pricing: {
    kicker: 'CENÍK',
    h2: 'Transparentní ceny. Předvídatelné. Férové.',
    sub: 'Vyberte tarif odpovídající vašemu vozovému parku. Měsíční výpověď.',
    allLink: 'Zobrazit všechny ceny',
    perMonth: '/ měsíc',
    badge: 'DOPORUČENO',
    cta: 'Domluvit demo',
    plans: [
      {
        name: 'STARTER', price: '€199', custom: false, scope: 'do 15 vozidel',
        features: ['Správa zakázek', 'Aplikace pro řidiče', 'GPS sledování', 'E-mailová podpora'],
      },
      {
        name: 'BUSINESS', price: '€499', custom: false, scope: 'do 50 vozidel',
        features: ['Vše z tarifu Starter', 'AI dispečink', 'Tachograf a EU 561', 'Prioritní podpora'],
      },
      {
        name: 'ENTERPRISE', price: 'Individuálně', custom: true, scope: '50+ vozidel',
        features: ['Vše z tarifu Business', 'Rozšířená oprávnění', 'API a integrace', 'Osobní kontakt'],
      },
    ],
    note: ['Menší vozové parky začínají levněji: ', 'BASIC od 49 €/měsíc', ' pro až 3 vozidla, ', 'DRIVER zdarma', ' pro živnostníky s jedním kamionem.'],
  },

  security: {
    title: 'Vaše data zůstávají v Evropě.',
    items: ['Hosting v Německu', 'V souladu s GDPR', '2FA a Passkeys', 'Auditní logy', 'Šifrování dat'],
  },

  faq: {
    kicker: 'FAQ',
    h2: 'Časté dotazy k TMS softwaru.',
    sub: 'Zůstaly otázky? Zodpovíme je na demu.',
    list: [
      {
        q: 'Co je TMS software?',
        a: 'Transport Management System spojuje zpracování zakázek, dispečink, správu vozidel a řidičů, dokumenty a fakturaci v jedné platformě — místo oddělených excelových tabulek, GPS portálů a účetních nástrojů.',
      },
      {
        q: 'Pro jaké dopravce je LOGIXA vhodná?',
        a: 'Pro dopravce a spedice od 3 do více než 50 vozidel. Živnostníci s jedním kamionem začínají na bezplatném tarifu DRIVER, malé vozové parky na BASIC od 49 €/měsíc, střední firmy na STARTER nebo BUSINESS.',
      },
      {
        q: 'Nahradí LOGIXA Excel?',
        a: 'Ano. Zakázky, řidiči, vozidla, číselníky a fakturace leží v jedné databázi místo v roztroušených tabulkách. Stávající soubory Excel a CSV převezmeme při přechodu — začínáte s vlastními daty.',
      },
      {
        q: 'Jak dlouho trvá zavedení?',
        a: 'Přechod plánujeme na 12 dní: analýza procesů, pilotní provoz s reálnými vozidly, import dat, školení a ostrý start. Ten harmonogram je náš postup, ne průměr měřený na zákaznických projektech.',
      },
      {
        q: 'Můžu si nechat stávající GPS?',
        a: 'V mnoha případech ano. LOGIXA snímá polohy přes aplikaci pro řidiče bez dalšího hardwaru a zároveň umí přebírat telematická data ze stávajících systémů. Jaké připojení je ve vašem případě možné, vyjasníme před startem.',
      },
      {
        q: 'Podporuje LOGIXA tachograf a EU 561?',
        a: 'Doby řízení a odpočinku podle EU 561 se u každého řidiče vyhodnocují průběžně, včetně varování před překročením. DDD soubory z tachografu lze importovat a prohlížet; jako úřední vyhodnocení tachografu pro kontrolní orgány toto vyhodnocení určeno není.',
      },
      {
        q: 'Existuje aplikace pro řidiče?',
        a: 'Ano, nativní aplikace pro iOS a Android v devíti jazycích: zakázka, navigace, sken dokumentů, podpis ePOD a uzavření trasy — i offline. K dispozici je navíc Telegram bot pro řidiče bez nainstalované aplikace.',
      },
      {
        q: 'Lze LOGIXA propojit s TIMOCOM a Trans.eu?',
        a: 'Konektory jsou připravené a napsané podle dokumentovaných rozhraní. Aktivace probíhá přes vaši vlastní smlouvu s TIMOCOM či Trans.eu; při zavádění spojení nastavíme společně a otestujeme s vašimi přístupy.',
      },
      {
        q: 'Kde jsou data uložena?',
        a: 'Na serverech v Německu, v souladu s GDPR, šifrovaně při přenosu i uložení. Přístupy se protokolují, přihlášení lze zabezpečit 2FA a Passkeys.',
      },
      {
        q: 'Kolik LOGIXA stojí?',
        a: 'DRIVER je zdarma pro živnostníky s jedním kamionem, BASIC začíná na 49 €/měsíc pro až 3 vozidla, STARTER stojí 199 €/měsíc do 15 vozidel, BUSINESS 499 €/měsíc do 50 vozidel. Nad 50 vozidel počítáme individuálně. Všechny tarify lze vypovědět měsíčně.',
      },
    ],
  },

  finalCta: {
    h2: 'Podívejte se na LOGIXA s vlastními dopravními procesy.',
    sub: 'Ve 30minutovém demu ukážeme přesně ty moduly, které jsou pro váš vozový park podstatné.',
    primary: 'Domluvit demo',
    secondary: 'Podívat se na demo',
  },

  footer: {
    tagline: 'TMS software pro dopravce a spedice v Evropě.',
    cols: [
      {
        title: 'PRODUKT',
        links: [
          { label: 'Funkce', href: '/platform/funktionen' },
          { label: 'AI dispečink', href: '/platform/ki' },
          { label: 'Aplikace pro řidiče', href: '/platform/funktionen#apps' },
          { label: 'Plánování tras', href: '/platform/funktionen#tourenplanung' },
          { label: 'Fakturace', href: '/platform/backoffice' },
        ],
      },
      {
        title: 'ŘEŠENÍ',
        links: [
          { label: 'Malí dopravci', href: '/pricing' },
          { label: 'Střední vozové parky', href: '/pricing' },
          { label: 'Dálková doprava', href: '/platform/funktionen' },
          { label: 'Živnostníci', href: '/pricing' },
        ],
      },
      {
        title: 'INTEGRACE',
        links: [
          { label: 'TIMOCOM', href: '/platform/integrationen' },
          { label: 'Trans.eu', href: '/platform/integrationen' },
          { label: 'DATEV', href: '/platform/integrationen' },
          { label: 'Telegram', href: '/platform/integrationen' },
          { label: 'Všechny integrace', href: '/platform/integrationen' },
        ],
      },
      {
        title: 'ZDROJE',
        links: [
          { label: 'Znalostní báze', href: '/docs' },
          { label: 'Blog', href: '/blog' },
          { label: 'Co je TMS?', href: '/docs' },
          { label: 'Náklady na TMS', href: '/pricing' },
          { label: 'Centrum nápovědy', href: '/docs' },
        ],
      },
      {
        title: 'SPOLEČNOST',
        links: [
          { label: 'O nás', href: '/about' },
          { label: 'Kariéra', href: '/jobs' },
          { label: 'Partneři', href: '/companies' },
          { label: 'Kontakt', href: '/kontakt' },
        ],
      },
    ],
    copyright: '© 2026 LOGIXA. Všechna práva vyhrazena.',
    legal: [
      { label: 'Ochrana údajů', href: '/datenschutz' },
      { label: 'Impressum', href: '/impressum' },
      { label: 'Podmínky', href: '/agb' },
      { label: 'Bezpečnost', href: '/platform/funktionen#sicherheit' },
    ],
  },
};
